<div class="container">
  <div class="text-center py-3">
    <img class="img-responsive" src="assets/logo_envoltis.png">
  </div>

  <div>
    <span *ngIf="allowedQueues()">
      <button type="button" class="btn btn-outline-secondary"
              placement="bottom"
              (click)="actionQueues()">
        Files SQS
      </button>
    </span>
    <span *ngIf="allowedLogs()">
      <button type="button" class="btn btn-outline-secondary"
              placement="bottom"
              (click)="actionLogs()">
        Logs Rails
      </button>
    </span>
    <span *ngFor="let debranchement of debranchements()">
      <button type="button" class="btn btn-outline-secondary"
              placement="bottom"
              (click)="actionDebranchement(debranchement.id)">
        {{ debranchement.title }}
      </button>
    </span>
  </div>

  <router-outlet></router-outlet>

</div>





// WEBPACK FOOTER //
// ./src/app/app.component.html